/**
 * @description renders the header of the knowledge center page
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';

const styles = {
  pageHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  }
};

/**
 * @props {Boolean} canAdmin - indicates if the user has permission to administrate the knowledge center
 * @props {(id: string) => void} onAdd - a callback function that's run when the user clicks the add entry button
 */
const Header = ({ canAdmin, onAdd }) => (
  <Typography variant='h4' sx={styles.pageHeader}>
    Knowledge Center
    {canAdmin && (
      <Button
        onClick={() => onAdd()}
        startIcon={<AddIcon />}
        variant='outlined'
      >
        Add Entry
      </Button>
    )}
  </Typography>
);

Header.propTypes = {
  canAdmin: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default Header;
